import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Link, useLocation } from 'react-router-dom';
import { supabase } from './supabaseClient';
import './App.css';
import InstallPWA from './InstallPWA';

import Login from './components/Login/Login';
import ElegirNickname from './components/ElegirNickname/ElegirNickname';
import Inicio from './Inicio/Inicio';
import EquipoTactico from './components/pages/EquipoTactico/EquipoTactico';
import EquipoLibre from './components/pages/EquipoLibre/EquipoLibre';
import TorneoPage from './components/pages/Torneos/TorneoPage';
import TorneoDetalle from './components/pages/Torneos/TorneoDetalle';
import AdminTorneo from './components/pages/Torneos/AdminTorneo';
import Palmares from './components/pages/Palmares/Palmares';
import RankingGeneral from './components/pages/Torneos/RankingGeneral';
import Prode from './components/pages/Prode/Prode';
import UnirseProde from './components/pages/UnirseProde/UnirseProde';
import MinijuegosHub from './components/Minijuegos/MinijuegosHub';
import AdminPuntos from './components/pages/Admin/AdminPuntos';
import MundialPage from './components/pages/Mundial/MundialPage';
import ModalSugerencias from './components/ModalSugerencias/ModalSugerencias';
import { ToastJugadaPreparada, ToastMedalla } from './components/Notificacion/Notificacion';
import { COORDENADAS_FORMACIONES } from './constants/tactics';
import ClanPage from './components/pages/Clan/ClanPage';
import RankedPage from './components/pages/Ranked/RankedPage';
import ModalCambioPassword from './components/ModalCambioPassword/ModalCambioPassword';
import TutorialMobile from './components/TutorialMobile/TutorialMobile';

function App() {
  // Auth
  const [session, setSession] = useState(null);
  const [loading, setLoading] = useState(true);
  const [esAdmin, setEsAdmin] = useState(false);
  const [nickname, setNickname] = useState('');
  const [nicknamePendiente, setNicknamePendiente] = useState(false);
  const [desafiosPendientes, setDesafiosPendientes] = useState([]);
  const [notifComodines, setNotifComodines] = useState([]);
  const [toastMedalla, setToastMedalla] = useState(null); // { tipo, emoji, nombre }

  // Jornada activa
  const [jornadaActiva, setJornadaActiva] = useState(1);
  const [jornadaViendo, setJornadaViendo] = useState(1);
  const jornadaViendoManualRef = React.useRef(false);
  const setJornadaViendoManual = (j) => { jornadaViendoManualRef.current = true; setJornadaViendo(j); };

  // Draft táctico
  const [mostrarSorteo, setMostrarSorteo] = useState(false);
  const [sorteoCheckpoint, setSorteoCheckpoint] = useState(null);
  const [draftResult, setDraftResult] = useState({ formacion: '4-3-3', presupuesto: 0, restricciones: [] });
  const [equipoActual, setEquipoActual] = useState({});
  const [confirmado, setConfirmado] = useState(false);
  const [capitanIndex, setCapitanIndex] = useState(null);
  const [ventana, setVentana] = useState(null);
  const [jornadasDisponibles, setJornadasDisponibles] = useState([]);
  const [efectosComodines, setEfectosComodines] = useState([]);
  const [presupuestoBonus, setPresupuestoBonus] = useState(0);

  // Equipo libre
  const [formacionLibre, setFormacionLibre] = useState('4-3-3');
  const [equipoLibre, setEquipoLibre] = useState({});

  // UI compartida
  const [mercadoAbierto, setMercadoAbierto] = useState(false);
  const [posicionSeleccionada, setPosicionSeleccionada] = useState(null);
  const [indexAEditar, setIndexAEditar] = useState(null);
  const [slotSeleccionado, setSlotSeleccionado] = useState(null);
  const [menuContextual, setMenuContextual] = useState(null);
  // ⚠️ NO BORRAR: mostrarSugerencias controla el modal de contacto del navbar
  const [mostrarSugerencias, setMostrarSugerencias] = useState(false);
  const [mostrarCambioPassword, setMostrarCambioPassword] = useState(false);
  // Mobile navbar
  const [menuMovilAbierto, setMenuMovilAbierto] = useState(false);
  const [submenuMovil, setSubmenuMovil] = useState(null); // 'equipo' | 'torneos' | 'minijuegos' | 'usuario'

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      setSession(session);
      if (session) fetchUserDraft(session.user.id);
      else setLoading(false);
    });
    let prevUserId = null;
    const { data: { subscription } } = supabase.auth.onAuthStateChange((_e, session) => {
      if (_e === 'PASSWORD_RECOVERY') {
    setMostrarCambioPassword(true);
    return;
  }
      setSession(session);
      if (session) {
        if (prevUserId && prevUserId !== session.user.id) {
          resetearEstado();
          fetchUserDraft(session.user.id);
          window.location.href = '/';
          return;
        }
        prevUserId = session.user.id;
        fetchUserDraft(session.user.id);
      } else {
        prevUserId = null;
        resetearEstado();
        setLoading(false);
        if (window.location.pathname !== '/') window.location.href = '/';
      }
    });
    return () => subscription.unsubscribe();
  }, []);

  // ⚠️ NO BORRAR: Realtime + focus para notificaciones de desafíos
  useEffect(() => {
    if (!session?.user?.id) return;
    cargarDesafiosPendientes(session.user.id);
    const onFocus = () => cargarDesafiosPendientes(session.user.id);
    window.addEventListener('focus', onFocus);
    const onComodinAplicado = () => fetchUserDraft(session.user.id);
    window.addEventListener('comodin_aplicado', onComodinAplicado);
    const canal = supabase.channel('desafios_notif')
      .on('postgres_changes', { event: '*', schema: 'public', table: 'desafios' },
        (payload) => {
          if (payload.new?.retado_id === session.user.id || payload.old?.retado_id === session.user.id) {
            cargarDesafiosPendientes(session.user.id);
          }
        })
      .subscribe();

    // Suscripción a notificaciones — TODAS las notificaciones del usuario en tiempo real
    const canalMedallas = supabase.channel('notif_realtime_' + session.user.id)
      .on('postgres_changes', {
        event: 'INSERT', schema: 'public', table: 'notificaciones',
        filter: `user_id=eq.${session.user.id}`,
      }, (payload) => {
        const n = payload.new;
        if (!n) return;

        // Agregar al badge de notificaciones
        setNotifComodines(prev => [n, ...prev]);

        // Toast según tipo
        if (n.tipo === 'jugada_preparada' || n.tipo === 'medalla' || n.tipo === 'hito') {
          const emojiLimpio = n.emoji && !n.emoji.includes('.png') && !n.emoji.includes('.jpg') ? n.emoji : '🏅';
          setToastMedalla({ tipo: n.tipo, emoji: emojiLimpio, nombre: n.texto?.replace('🏅 Nuevo hito: ', '').replace('¡Desbloqueaste una Jugada Preparada! ', '') || n.texto || '' });
        } else if (n.tipo === 'comodin' || n.tipo === 'comodin_recibido') {
          setToastMedalla({ tipo: 'comodin', emoji: '', nombre: n.texto || 'Recibiste un comodín' });
        } else if (n.tipo === 'guerra' || n.tipo === 'clan') {
          setToastMedalla({ tipo: 'clan', emoji: '', nombre: n.texto || 'Novedad en tu clan' });
        } else if (n.tipo === 'sabotaje') {
          setToastMedalla({ tipo: 'sabotaje', emoji: '', nombre: n.texto || 'Te sabotearon' });
        } else if (n.tipo === 'prode') {
          setToastMedalla({ tipo: 'prode', emoji: '', nombre: n.texto || 'Puntos del prode' });
        }
        // desafios_ranked se maneja por cargarDesafiosPendientes arriba
      })
      .subscribe();

    return () => {
      window.removeEventListener('focus', onFocus);
      window.removeEventListener('comodin_aplicado', onComodinAplicado);
      supabase.removeChannel(canal);
      supabase.removeChannel(canalMedallas);
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [session?.user?.id]);

  const resetearEstado = () => {
    limpiarCache();
    setDraftResult({ formacion: '4-3-3', presupuesto: 0, restricciones: [] });
    setEquipoActual({}); setEquipoLibre({}); setFormacionLibre('4-3-3');
    setEsAdmin(false); setNickname(''); setNicknamePendiente(false);
    setMostrarSorteo(false); setJornadaActiva(1); setJornadaViendo(1);
    setConfirmado(false); setCapitanIndex(null); setVentana(null);
    setJornadasDisponibles([]); setEfectosComodines([]); setPresupuestoBonus(0);
  };

  // ⚠️ NO BORRAR: cache para evitar parpadeo al volver de otra pestaña
  const CACHE_KEY = 'dtxi_draft_cache';
  const guardarCache = (obj) => { try { sessionStorage.setItem(CACHE_KEY, JSON.stringify(obj)); } catch(e) {} };
  const limpiarCache = () => { try { sessionStorage.removeItem(CACHE_KEY); } catch(e) {} };
  const leerCache = (uid) => { try { const d = sessionStorage.getItem(CACHE_KEY); const p = d ? JSON.parse(d) : null; return p?.userId === uid ? p : null; } catch(e) { return null; } };

  const fetchUserDraft = async (userId) => {
    const cached = leerCache(userId);
    // Verificar si el caché corresponde a la jornada activa actual antes de usarlo
    const ventanaActual = await supabase.from('ventana_transferencias').select('numero_fecha').eq('activa', true).order('numero_fecha', {ascending: false}).limit(1).maybeSingle().then(r => r.data?.numero_fecha || 1);
    if (cached) {
      const jornadaEnCache = cached.jornadaActiva || 1;
      // Solo cargar del caché datos que no dependen de la jornada
      if (cached.esAdmin != null) setEsAdmin(cached.esAdmin);
      if (cached.nickname) setNickname(cached.nickname);
      // Limpiar caché si la jornada cambió
      if (jornadaEnCache !== ventanaActual) {
        limpiarCache();
      }
    }
    try {
      const { data: perfil } = await supabase.from('perfiles').select('es_admin, nickname').eq('id', userId).single();
      setEsAdmin(perfil?.es_admin || false);
      setNickname(perfil?.nickname || '');
      if (!perfil?.nickname) setNicknamePendiente(true);
      else setNicknamePendiente(false);

      const { data: ventana } = await supabase.from('ventana_transferencias')
        .select('*').eq('activa', true)
        .order('numero_fecha', { ascending: false }).limit(1).maybeSingle();
      const jornada = ventana?.numero_fecha || ventanaActual;
      setJornadaActiva(jornada);
      if (!jornadaViendoManualRef.current) setJornadaViendo(jornada);

      const { data, error } = await supabase.from('drafts').select('*')
        .eq('user_id', userId).eq('jornada', jornada).maybeSingle();

      const { data: todasJornadas } = await supabase.from('drafts')
        .select('jornada, confirmado').eq('user_id', userId).order('jornada');
      setJornadasDisponibles(todasJornadas || []);
      setVentana(ventana || null);

      if (data && !error) {
        setConfirmado(data.confirmado || false);
        setCapitanIndex(data.capitan_index ?? null);
        const efectos = data.efectos_comodines || [];
        setEfectosComodines(efectos);
        const bonus = efectos.filter(e => typeof e.tipo === 'string' && e.tipo.startsWith('dinero_extra') && e.monto > 0).reduce((acc, e) => acc + (e.monto || 0), 0);
const negativos = efectos.filter(e => e.monto < 0).reduce((acc, e) => acc + (e.monto || 0), 0);
setPresupuestoBonus(bonus + negativos);
        limpiarCache();
        setDraftResult({ formacion: data.formacion, presupuesto: data.presupuesto, restricciones: data.restricciones || [] });

        const { data: drafLibre } = await supabase.from('drafts')
          .select('equipo_libre, formacion_libre, capitan_index_libre')
          .eq('user_id', userId).eq('jornada', jornada).maybeSingle();
        // Fallback a jornada 0 si la activa no tiene equipo libre
        const drafLibreData = (drafLibre?.equipo_libre && Object.keys(drafLibre.equipo_libre).length > 0) ? drafLibre : null;
        const { data: drafLibre0 } = !drafLibreData ? await supabase.from('drafts')
          .select('equipo_libre, formacion_libre, capitan_index_libre')
          .eq('user_id', userId).eq('jornada', 0).maybeSingle() : { data: null };
        const dLibre = drafLibreData || drafLibre0;
        if (dLibre?.equipo_libre && Object.keys(dLibre.equipo_libre).length > 0) setEquipoLibre(dLibre.equipo_libre);
        if (dLibre?.formacion_libre) setFormacionLibre(dLibre.formacion_libre);

        if (data.equipo && Object.keys(data.equipo).length > 0) {
          const ids = Object.values(data.equipo).filter(Boolean).map(j => j.id).filter(Boolean);
          if (ids.length > 0) {
            // ⚠️ ADVERTENCIA: NO borrar contexto, seleccion ni liga_club
            // Son OBLIGATORIOS para que CardJugador muestre las camisetas de selecciones del Mundial
            const { data: frescos } = await supabase.from('jugadores').select(`
              id, nombre, apellido, precio, pie_habil, nacionalidad, fecha_nacimiento, altura, status, dorsal,
              contexto, seleccion, liga_club, ex_ligas,
              posicion:posiciones(sigla), club:clubes(sigla)
            `).in('id', ids);
            if (frescos) {
              const mapa = {};
              frescos.forEach(j => { mapa[j.id] = j; });
              const enriquecido = {};
              Object.entries(data.equipo).forEach(([slot, j]) => {
                enriquecido[slot] = j?.id && mapa[j.id] ? mapa[j.id] : j;
              });
              setEquipoActual(enriquecido);
            } else setEquipoActual(data.equipo);
          } else setEquipoActual({});
        } else setEquipoActual({});

        // Sorteo en progreso (checkpoint) — mostrar y retomar
        if (!data.ruleta_girada && data.sorteo_paso > 0 && data.sorteo_paso < 99) {
          setSorteoCheckpoint({ sorteo_paso: data.sorteo_paso, sorteo_temp: data.sorteo_temp || {} });
          setMostrarSorteo(true);
        } else {
          setSorteoCheckpoint(null);
          setMostrarSorteo(!data.ruleta_girada);
        }
      } else {
        setDraftResult({ formacion: '4-3-3', presupuesto: 0, restricciones: [] });
        setEquipoActual({});
        setMostrarSorteo(ventana !== null);
        const { data: drafLibre2 } = await supabase.from('drafts')
          .select('equipo_libre, formacion_libre')
          .eq('user_id', userId).eq('jornada', jornada).maybeSingle();
        const dLibre2 = (drafLibre2?.equipo_libre && Object.keys(drafLibre2.equipo_libre).length > 0) ? drafLibre2 : null;
        if (!dLibre2) {
          const { data: drafLibre2_0 } = await supabase.from('drafts')
            .select('equipo_libre, formacion_libre').eq('user_id', userId).eq('jornada', 0).maybeSingle();
          if (drafLibre2_0?.equipo_libre && Object.keys(drafLibre2_0.equipo_libre).length > 0) setEquipoLibre(drafLibre2_0.equipo_libre);
          if (drafLibre2_0?.formacion_libre) setFormacionLibre(drafLibre2_0.formacion_libre);
        } else {
          if (dLibre2.equipo_libre) setEquipoLibre(dLibre2.equipo_libre);
          if (dLibre2.formacion_libre) setFormacionLibre(dLibre2.formacion_libre);
        }
      }
    } catch (err) { console.error(err); }
    finally { setLoading(false); cargarDesafiosPendientes(userId); }
  };

  const cargarDesafiosPendientes = async (userId) => {
    const [{ data: desafios }, { data: notifs }] = await Promise.all([
      supabase.from('desafios')
        .select('*, retador:perfiles!desafios_retador_perfiles_fkey(nickname, clan_tag)')
        .eq('retado_id', userId).eq('estado', 'pendiente')
        .order('created_at', { ascending: false }),
      supabase.from('notificaciones')
        .select('*').eq('user_id', userId).eq('leida', false)
        .order('created_at', { ascending: false }),
    ]);
    setDesafiosPendientes(desafios || []);
    setNotifComodines(notifs || []);
  };

  const responderDesafio = async (desafioId, aceptar) => {
    await supabase.from('desafios').update({ estado: aceptar ? 'activo' : 'rechazado' }).eq('id', desafioId);
    cargarDesafiosPendientes(session?.user?.id);
    // ⚠️ NO BORRAR: notificar al RankedPage para que recargue
    window.dispatchEvent(new Event('desafio_respondido'));
  };

  // ⚠️ NO BORRAR: guarda cache automáticamente cuando cambian datos clave
  useEffect(() => {
    if (!session?.user?.id || loading) return;
    guardarCache({
      userId: session.user.id,
      draftResult, equipoActual, equipoLibre, formacionLibre,
      jornadaActiva, confirmado, capitanIndex, ventana,
      jornadasDisponibles, efectosComodines, presupuestoBonus,
      esAdmin, nickname,
    });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [draftResult, equipoActual, equipoLibre, formacionLibre, jornadaActiva,
      confirmado, capitanIndex, ventana, jornadasDisponibles,
      efectosComodines, presupuestoBonus, esAdmin, nickname]);

  const calcularEdad = (fecha) => {
    if (!fecha) return null;
    const hoy = new Date(), nac = new Date(fecha);
    let edad = hoy.getFullYear() - nac.getFullYear();
    if (hoy.getMonth() < nac.getMonth() || (hoy.getMonth() === nac.getMonth() && hoy.getDate() < nac.getDate())) edad--;
    return edad;
  };

  const obtenerRestriccionesValidadas = () => {
    const jugadores = Object.entries(equipoActual)
      .filter(([k]) => Number(k) <= 10)
      .map(([, v]) => v)
      .filter(Boolean)
      .filter(j => j.status !== 'no_juega');
    if (!jugadores.length) return draftResult.restricciones.map(r => ({ ...r, cumplida: false, jugadoresRelevantes: [] }));

    // ── Nombres de país — exactamente como están en la DB ──
    const SUDAMERICANOS      = ['Argentina','Brasil','Uruguay','Colombia','Chile','Paraguay','Venezuela','Bolivia','Ecuador','Perú'];
    const AFRICANOS          = ['Marruecos','Senegal','Mali','Sudáfrica','Túnez','Ghana','Nigeria','RD Congo','Camerún','Egipto','Costa de Marfil','Argelia','Cabo Verde'];
    const ASIATICOS          = ['Japón','Corea del Sur','Irán','Arabia Saudita','Qatar','Australia','Uzbekistán','Jordania','Irak','Nueva Zelanda'];
    const EUROPEOS           = ['España','Francia','Alemania','Inglaterra','Portugal','Países Bajos','Bélgica','Croacia','Serbia','Dinamarca','Suecia','Noruega','Austria','Suiza','Turquía','Escocia','República Checa','Polonia','Ucrania','Rumanía','Hungría','Eslovenia','Albania','Georgia','Bosnia','Italia'];
    const CONCACAF           = ['México','USA','Canadá','Panamá','Jamaica','Honduras','Costa Rica','Guatemala','Cuba','Haití','Curazao'];
    const OCEANIA            = ['Australia','Nueva Zelanda'];
    const CAMPEONES_MUNDO    = ['Argentina','Brasil','Uruguay','España','Francia','Inglaterra','Italia','Alemania'];
    const FINALISTAS_ARG_FRA = ['Argentina','Francia'];
    const AMERICA            = [...SUDAMERICANOS, ...CONCACAF];
    const TOP3_FIFA          = ['Francia','España','Argentina'];
    const PEORES3_FIFA       = ['Nueva Zelanda','Haití','Curazao'];

    // norm: quita tildes y pasa a minúsculas (para keywords del doc5 que usan norm)
    const norm = (s) => (s || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');

    return draftResult.restricciones.map(res => {
      const t = res.texto.toLowerCase();
      const tn = norm(res.texto); // versión sin tildes para keywords que lo requieran
      let cumplida = false;
      let relevantes = [];

      const numMax = (regex, def) => { const m = t.match(regex); return m ? parseInt(m[1]) : def; };
      const esMáx = t.includes('máx') || t.includes('maximo') || t.includes('máximo') || tn.includes('maximo') || tn.includes('ningun') || tn.includes('max');

      // ── Edad +33 ──
      if (tn.includes('+33') || (tn.includes('33') && tn.includes('ano'))) {
        relevantes = jugadores.filter(j => { const e = calcularEdad(j.fecha_nacimiento); return e !== null && e >= 33; });
        const cant = numMax(/(\d+)/i, 1);
        cumplida = esMáx ? relevantes.length <= cant : relevantes.length >= cant;

      // ── Edad +35 ──
      } else if (t.includes('+35') || t.includes('35 año') || (t.includes('35') && t.includes('año')) || tn.includes('+35') || (tn.includes('35') && tn.includes('ano'))) {
        relevantes = jugadores.filter(j => { const e = calcularEdad(j.fecha_nacimiento); return e !== null && e >= 35; });
        const cant = numMax(/(\d+)\s*jugador/i, 2);
        cumplida = esMáx ? relevantes.length <= cant : relevantes.length >= cant;

      // ── Edad +36 ──
      } else if (t.includes('+36') || t.includes('36 año') || (t.includes('36') && t.includes('año')) || tn.includes('+36') || (tn.includes('36') && tn.includes('ano'))) {
        relevantes = jugadores.filter(j => { const e = calcularEdad(j.fecha_nacimiento); return e !== null && e >= 36; });
        const cant = numMax(/(\d+)\s*jugador/i, 2);
        cumplida = esMáx ? relevantes.length <= cant : relevantes.length >= cant;

      // ── Altura ──
      } else if (t.includes('1.82') || t.includes('1,82') || t.includes('+1.82') ||
                 t.includes('1.80') || t.includes('1,80') || t.includes('+1.80') || t.includes('altura')) {
        const altMatch = t.match(/1[,.](\d{2})/);
        const altMin = altMatch ? parseFloat('1.' + altMatch[1]) * 100 : 182;
        relevantes = jugadores.filter(j => j.altura != null && Number(j.altura) >= altMin);
        const cant = numMax(/(\d+)\s*jugador/i, 3);
        cumplida = relevantes.length >= cant;

      // ── Precio ──
      } else if (t.includes('$5.5') || t.includes('5,5m') || t.includes('5.5m') ||
                 t.includes('$5m') || t.includes('precio') || t.includes('máx $')) {
        const precMatch = t.match(/\$?(\d+(?:[.,]\d+)?)\s*m/i);
        const precMax = precMatch ? parseFloat(precMatch[1].replace(',','.')) * 1_000_000 : 5_500_000;
        relevantes = jugadores.filter(j => j.precio > precMax);
        const cantMax = numMax(/(\d+)\s*jugador/i, 3);
        cumplida = esMáx ? relevantes.length <= cantMax : relevantes.length === 0;

      // ── Ex ligas ──
      } else if (t.includes('serie a') && (t.includes('ex') || t.includes('jugaron'))) {
        relevantes = jugadores.filter(j => j.ex_ligas?.includes('Serie A'));
        const cant = numMax(/(\d+)/i, 2);
        cumplida = esMáx ? relevantes.length <= cant : relevantes.length >= cant;

      } else if (t.includes('premier') && (t.includes('ex') || t.includes('jugaron') || t.includes('jugó'))) {
        relevantes = jugadores.filter(j => j.ex_ligas?.includes('Premier League'));
        const cant = numMax(/(\d+)/i, 2);
        cumplida = esMáx ? relevantes.length <= cant : relevantes.length >= cant;

      } else if ((t.includes('la liga') || t.includes('liga española')) && (t.includes('ex') || t.includes('jugaron'))) {
        relevantes = jugadores.filter(j => j.ex_ligas?.includes('La Liga'));
        const cant = numMax(/(\d+)/i, 2);
        cumplida = esMáx ? relevantes.length <= cant : relevantes.length >= cant;

      } else if ((t.includes('ligue 1') || t.includes('liga francesa')) && (t.includes('ex') || t.includes('jugaron'))) {
        relevantes = jugadores.filter(j => j.ex_ligas?.includes('Ligue 1'));
        const cant = numMax(/(\d+)/i, 2);
        cumplida = esMáx ? relevantes.length <= cant : relevantes.length >= cant;

      } else if ((t.includes('bundesliga') || t.includes('liga alemana')) && (t.includes('ex') || t.includes('jugaron'))) {
        relevantes = jugadores.filter(j => j.ex_ligas?.includes('Bundesliga'));
        const cant = numMax(/(\d+)/i, 2);
        cumplida = esMáx ? relevantes.length <= cant : relevantes.length >= cant;

      // ── Ligas actuales ──
      } else if (t.includes('premier') && !t.includes('ex') && !t.includes('jugaron')) {
        relevantes = jugadores.filter(j => j.liga_club === 'Premier League');
        const cant = numMax(/(\d+)/i, 2);
        cumplida = esMáx ? relevantes.length <= cant : relevantes.length >= cant;

      } else if ((t.includes('la liga') || t.includes('liga española')) && !t.includes('ex') && !t.includes('jugaron')) {
        relevantes = jugadores.filter(j => j.liga_club === 'La Liga');
        const cant = numMax(/(\d+)/i, 2);
        cumplida = esMáx ? relevantes.length <= cant : relevantes.length >= cant;

      } else if (t.includes('serie a') && !t.includes('ex') && !t.includes('jugaron')) {
        relevantes = jugadores.filter(j => j.liga_club === 'Serie A');
        const cant = numMax(/(\d+)/i, 2);
        cumplida = esMáx ? relevantes.length <= cant : relevantes.length >= cant;

      } else if ((t.includes('bundesliga') || t.includes('liga alemana')) && !t.includes('ex') && !t.includes('jugaron')) {
        relevantes = jugadores.filter(j => j.liga_club === 'Bundesliga');
        const cant = numMax(/(\d+)/i, 2);
        cumplida = esMáx ? relevantes.length <= cant : relevantes.length >= cant;

      } else if ((t.includes('ligue 1') || t.includes('liga francesa')) && !t.includes('ex') && !t.includes('jugaron')) {
        relevantes = jugadores.filter(j => j.liga_club === 'Ligue 1');
        const cant = numMax(/(\d+)/i, 2);
        cumplida = esMáx ? relevantes.length <= cant : relevantes.length >= cant;

      // ── Ligas distintas ──
      } else if (t.includes('liga') && t.includes('distinta')) {
        const ligas = new Set(jugadores.map(j => j.liga_club).filter(Boolean));
        const cant = numMax(/(\d+)/i, 3);
        cumplida = ligas.size >= cant;
        relevantes = [...ligas].map(liga => jugadores.find(j => j.liga_club === liga)).filter(Boolean);

      // ── POSICIÓN + CONTINENTE (siempre ANTES que los genéricos de continente) ──
      } else if (t.includes('defensor') && t.includes('african')) {
        relevantes = jugadores.filter(j => j.posicion?.sigla === 'DEF' && AFRICANOS.includes(j.nacionalidad));
        const cant = numMax(/(\d+)/i, 1);
        cumplida = relevantes.length >= cant;

      } else if (t.includes('defensor') && t.includes('europe')) {
        relevantes = jugadores.filter(j => j.posicion?.sigla === 'DEF' && EUROPEOS.includes(j.nacionalidad));
        const cant = numMax(/(\d+)/i, 1);
        cumplida = esMáx ? relevantes.length <= cant : relevantes.length >= cant;

      } else if (t.includes('defensor') && t.includes('sudamericano')) {
        relevantes = jugadores.filter(j => j.posicion?.sigla === 'DEF' && SUDAMERICANOS.includes(j.nacionalidad));
        const cant = numMax(/(\d+)/i, 1);
        cumplida = esMáx ? relevantes.length <= cant : relevantes.length >= cant;

      } else if (t.includes('delantero') && t.includes('african')) {
        relevantes = jugadores.filter(j => j.posicion?.sigla === 'DEL' && AFRICANOS.includes(j.nacionalidad));
        const cant = numMax(/(\d+)/i, 1);
        cumplida = relevantes.length >= cant;

      } else if (t.includes('delantero') && t.includes('europe')) {
        relevantes = jugadores.filter(j => j.posicion?.sigla === 'DEL' && EUROPEOS.includes(j.nacionalidad));
        const cant = numMax(/(\d+)/i, 1);
        cumplida = esMáx ? relevantes.length <= cant : relevantes.length >= cant;

      } else if (t.includes('delantero') && t.includes('sudamericano')) {
        relevantes = jugadores.filter(j => j.posicion?.sigla === 'DEL' && SUDAMERICANOS.includes(j.nacionalidad));
        const cant = numMax(/(\d+)/i, 1);
        cumplida = esMáx ? relevantes.length <= cant : relevantes.length >= cant;

      } else if (t.includes('volante') && t.includes('african')) {
        relevantes = jugadores.filter(j => j.posicion?.sigla === 'VOL' && AFRICANOS.includes(j.nacionalidad));
        const cant = numMax(/(\d+)/i, 1);
        cumplida = relevantes.length >= cant;

      } else if (t.includes('volante') && t.includes('europe')) {
        relevantes = jugadores.filter(j => j.posicion?.sigla === 'VOL' && EUROPEOS.includes(j.nacionalidad));
        const cant = numMax(/(\d+)/i, 1);
        cumplida = esMáx ? relevantes.length <= cant : relevantes.length >= cant;

      } else if (t.includes('volante') && t.includes('sudamericano')) {
        relevantes = jugadores.filter(j => j.posicion?.sigla === 'VOL' && SUDAMERICANOS.includes(j.nacionalidad));
        const cant = numMax(/(\d+)/i, 1);
        cumplida = esMáx ? relevantes.length <= cant : relevantes.length >= cant;

      // ── Continentes genéricos (DESPUÉS de posición+continente) ──
      } else if (t.includes('african') || t.includes('africa')) {
        relevantes = jugadores.filter(j => AFRICANOS.includes(j.nacionalidad));
        const cant = numMax(/(\d+)/i, 1);
        cumplida = esMáx ? relevantes.length <= cant : relevantes.length >= cant;

      } else if (t.includes('sudamericano')) {
        relevantes = jugadores.filter(j => SUDAMERICANOS.includes(j.nacionalidad));
        const cant = numMax(/(\d+)\s*sudamericano/i, 3);
        cumplida = esMáx ? relevantes.length <= cant : relevantes.length >= cant;

      } else if (t.includes('asiático') || t.includes('asiatico') || t.includes('asia')) {
        relevantes = jugadores.filter(j => ASIATICOS.includes(j.nacionalidad));
        const cant = numMax(/(\d+)/i, 2);
        cumplida = relevantes.length >= cant;

      } else if (t.includes('europe') || t.includes('europeo')) {
        relevantes = jugadores.filter(j => EUROPEOS.includes(j.nacionalidad));
        const cant = numMax(/(\d+)/i, 3);
        cumplida = esMáx ? relevantes.length <= cant : relevantes.length >= cant;

      } else if (t.includes('concacaf') || t.includes('centroameric') || t.includes('norteameric')) {
        relevantes = jugadores.filter(j => CONCACAF.includes(j.nacionalidad));
        const cant = numMax(/(\d+)/i, 2);
        cumplida = relevantes.length >= cant;

      // ── Campeones / Finalistas ──
      } else if (t.includes('campe') && t.includes('mundo')) {
        relevantes = jugadores.filter(j => CAMPEONES_MUNDO.includes(j.nacionalidad));
        const cant = numMax(/(\d+)/i, 6);
        cumplida = esMáx ? relevantes.length <= cant : relevantes.length >= cant;

      } else if (t.includes('finalista') || (t.includes('argentina') && t.includes('francia'))) {
        relevantes = jugadores.filter(j => FINALISTAS_ARG_FRA.includes(j.nacionalidad));
        const cant = numMax(/(\d+)/i, 3);
        cumplida = esMáx ? relevantes.length <= cant : relevantes.length >= cant;

      } else if (t.includes('último campeón') || t.includes('ultimo campeon') || t.includes('ultimo campeon')) {
        relevantes = jugadores.filter(j => j.nacionalidad === 'Argentino');
        const cant = numMax(/(\d+)/i, 2);
        cumplida = relevantes.length <= cant;

      // ── Sub-21 / Sub-23 ──
      } else if (t.includes('sub-21') || t.includes('sub21')) {
        relevantes = jugadores.filter(j => { const e = calcularEdad(j.fecha_nacimiento); return e !== null && e <= 21; });
        const cant = numMax(/(\d+)/i, 2);
        cumplida = relevantes.length >= cant;

      } else if (t.includes('sub-23') || t.includes('sub23')) {
        relevantes = jugadores.filter(j => { const e = calcularEdad(j.fecha_nacimiento); return e !== null && e <= 23; });
        const cant = numMax(/(\d+)/i, 2);
        cumplida = relevantes.length >= cant;

      // ── Mismo país ──
      } else if (t.includes('mismo pa') || t.includes('mismo país')) {
        const porPais = {};
        jugadores.forEach(j => { const n = j.nacionalidad || 'SC'; porPais[n] = (porPais[n] || 0) + 1; });
        const cant = numMax(/(\d+)/i, 2);
        cumplida = Object.values(porPais).every(c => c <= cant);
        relevantes = jugadores.filter(j => (porPais[j.nacionalidad || 'SC'] || 0) > cant);

      // ── Zurdos ──
      } else if (t.includes('zurdo')) {
        relevantes = jugadores.filter(j => j.pie_habil === 'Izquierdo');
        const cant = numMax(/(\d+)/i, 2);
        cumplida = relevantes.length >= cant;

      // ── Extranjeros ──
      } else if (t.includes('extranjero')) {
        relevantes = jugadores.filter(j => j.nacionalidad !== 'Argentino');
        const cant = numMax(/(\d+)/i, 2);
        cumplida = esMáx ? relevantes.length <= cant : relevantes.length >= cant;

      // ── Solo locales ──
      } else if (t.includes('local') || t.includes('solo local')) {
        relevantes = jugadores.filter(j => j.nacionalidad === 'Argentino');
        cumplida = jugadores.every(j => j.nacionalidad === 'Argentino');

      // ── Sin Top 5 ──
      } else if (t.includes('top 5') || t.includes('sin top') || t.includes('sin grandes')) {
        relevantes = jugadores.filter(j => ['RIV','BOC','IND','SAN','RAC'].includes(j.club?.sigla));
        cumplida = relevantes.length === 0;

      // ── River / Boca ──
      } else if (t.includes('river') || t.includes('riv')) {
        relevantes = jugadores.filter(j => j.club?.sigla === 'RIV');
        cumplida = relevantes.length >= 2;

      } else if (t.includes('boca') || t.includes('boc')) {
        relevantes = jugadores.filter(j => j.club?.sigla === 'BOC');
        cumplida = relevantes.length >= 2;

      // ── Mismo club ──
      } else if (t.includes('mismo club')) {
        const porClub = {};
        jugadores.forEach(j => { const s = j.club?.sigla || 'SC'; porClub[s] = (porClub[s] || 0) + 1; });
        const cant = numMax(/(\d+)/i, 2);
        cumplida = Object.values(porClub).every(c => c <= cant);
        relevantes = jugadores.filter(j => (porClub[j.club?.sigla || 'SC'] || 0) > cant);

      // ── Oceania ──
      } else if (tn.includes('oceania')) {
        relevantes = jugadores.filter(j => OCEANIA.includes(j.nacionalidad));
        const cant = numMax(/(\d+)/i, 1);
        cumplida = esMáx ? relevantes.length <= cant : relevantes.length >= cant;

      // ── América (CONMEBOL + CONCACAF) ──
      } else if (tn.includes('de america') || tn.includes('de am')) {
        relevantes = jugadores.filter(j => AMERICA.includes(j.nacionalidad));
        const cant = numMax(/(\d+)/i, 1);
        cumplida = esMáx ? relevantes.length <= cant : relevantes.length >= cant;

      // ── Última final del mundial (ARG + FRA) ──
      } else if (tn.includes('ultima final') || tn.includes('ltima final')) {
        relevantes = jugadores.filter(j => FINALISTAS_ARG_FRA.includes(j.nacionalidad));
        const cant = numMax(/(\d+)/i, 1);
        cumplida = esMáx ? relevantes.length <= cant : relevantes.length >= cant;

      // ── Ranking FIFA — 3 mejores / 3 peores ──
      } else if (tn.includes('3 mejores') || tn.includes('mejores selecciones')) {
        relevantes = jugadores.filter(j => TOP3_FIFA.includes(j.nacionalidad));
        cumplida = relevantes.length === 0; // "ningún jugador de las 3 mejores"

      } else if (tn.includes('3 peores') || tn.includes('peores selecciones')) {
        relevantes = jugadores.filter(j => PEORES3_FIFA.includes(j.nacionalidad));
        const cant = numMax(/(\d+)/i, 1);
        cumplida = relevantes.length >= cant;

      // ── Misma selección ──
      } else if (tn.includes('misma selecci')) {
        const porSel = {};
        jugadores.forEach(j => { const s = j.seleccion || j.nacionalidad || 'SC'; porSel[s] = (porSel[s] || 0) + 1; });
        const cant = numMax(/(\d+)/i, 2);
        cumplida = Object.values(porSel).some(c => c >= cant);
        relevantes = jugadores.filter(j => (porSel[j.seleccion || j.nacionalidad || 'SC'] || 0) >= cant);

      // ── Ex Eredivisie ──
      } else if (tn.includes('ex eredivisie')) {
        relevantes = jugadores.filter(j => j.ex_ligas?.includes('Eredivisie'));
        const cant = numMax(/(\d+)/i, 2);
        cumplida = esMáx ? relevantes.length <= cant : relevantes.length >= cant;

      // ── Eredivisie actual ──
      } else if (tn.includes('eredivisie') && !tn.includes('ex')) {
        relevantes = jugadores.filter(j => j.liga_club === 'Eredivisie');
        const cant = numMax(/(\d+)/i, 2);
        cumplida = esMáx ? relevantes.length <= cant : relevantes.length >= cant;

      // ── Precio máx $6.5M (keyword legacy) ──
      } else if (tn.includes('6.5') || tn.includes('6,5')) {
        relevantes = jugadores.filter(j => j.precio > 6_500_000);
        const cant = numMax(/(\d+)/i, 1);
        cumplida = relevantes.length <= cant;

      // ── Dorsales ──
      } else if (tn.includes('dorsal') && tn.includes('10')) {
        relevantes = jugadores.filter(j => Number(j.dorsal) === 10);
        const cant = numMax(/(\d+)/i, 1);
        cumplida = esMáx ? relevantes.length <= cant : relevantes.length >= cant;

      } else if (tn.includes('dorsal') && tn.includes('11')) {
        relevantes = jugadores.filter(j => Number(j.dorsal) === 11);
        const cant = numMax(/(\d+)/i, 1);
        cumplida = esMáx ? relevantes.length <= cant : relevantes.length >= cant;

      } else if (tn.includes('dorsal') && tn.includes(' 9') && !tn.includes('11')) {
        relevantes = jugadores.filter(j => Number(j.dorsal) === 9);
        const cant = numMax(/(\d+)/i, 1);
        cumplida = esMáx ? relevantes.length <= cant : relevantes.length >= cant;

      } else if (tn.includes('dorsal') && tn.includes(' 7')) {
        relevantes = jugadores.filter(j => Number(j.dorsal) === 7);
        const cant = numMax(/(\d+)/i, 1);
        cumplida = esMáx ? relevantes.length <= cant : relevantes.length >= cant;
      }

      return { ...res, cumplida, jugadoresRelevantes: relevantes };
    });
  };

  if (loading) return <div className="loading-screen">Cargando...</div>;
  if (!session) {
    // Permitir acceso a /unirse/:codigo sin sesión
    if (window.location.pathname.startsWith('/unirse/')) {
      return <UnirseProde session={null} />;
    }
    return <Login />;
  }

  if (nicknamePendiente) return (
    <ElegirNickname
      session={session}
      onNicknameGuardado={(nick) => { setNickname(nick); setNicknamePendiente(false); }}
    />
  );

  const posActual = COORDENADAS_FORMACIONES[draftResult.formacion] || COORDENADAS_FORMACIONES['4-3-3'];
  const restriccionesActualizadas = obtenerRestriccionesValidadas();
  const uiProps = { mercadoAbierto, setMercadoAbierto, posicionSeleccionada, setPosicionSeleccionada, indexAEditar, setIndexAEditar, slotSeleccionado, setSlotSeleccionado, menuContextual, setMenuContextual };

  // ── Copiar equipo entre modos ─────────────────────────────────────────────
  const copiarTacticoALibre = async () => {
    const titulares = Object.fromEntries(Object.entries(equipoActual).filter(([k]) => Number(k) <= 10));
    if (Object.keys(titulares).length === 0) return alert('No tenés titulares en el equipo táctico.');
    const costo = Object.values(titulares).reduce((acc, j) => acc + (j?.precio || 0), 0);
    const msg = costo > 60000000
      ? `El equipo táctico cuesta $${(costo/1000000).toFixed(1)}M y supera los $60M del modo libre. ¿Copiarlo igual?`
      : '¿Copiar el equipo táctico al modo libre?';
    if (!window.confirm(msg)) return; // App.js no tiene useConfirm — esto se puede mejorar en el futuro
    const formNueva = draftResult?.formacion || formacionLibre || '4-3-3';
    setEquipoLibre(titulares);
    setFormacionLibre(formNueva);
    await supabase.from('drafts').upsert({
      user_id: session.user.id, jornada: 0,
      equipo_libre: titulares, formacion_libre: formNueva, confirmado: false,
    }, { onConflict: 'user_id,jornada' });
    alert('✓ Equipo copiado al modo libre.');
  };

  const copiarLibreATactico = async () => {
    const titulares = Object.fromEntries(Object.entries(equipoLibre).filter(([k]) => Number(k) <= 10));
    if (Object.keys(titulares).length === 0) return alert('No tenés titulares en el equipo libre.');
    if (!window.confirm('¿Copiar el equipo libre al modo táctico? Se reemplazarán los titulares actuales.')) return; // TODO: usar modal custom
    const nuevo = { ...equipoActual, ...titulares };
    setEquipoActual(nuevo);
    if (session?.user?.id && jornadaActiva) {
      await supabase.from('drafts').upsert({
        user_id: session.user.id, jornada: jornadaActiva,
        equipo: nuevo, confirmado: false,
      }, { onConflict: 'user_id,jornada' });
    }
    alert('✓ Equipo copiado al modo táctico.');
  };

  return (
    <Router>
      <div style={{ backgroundColor: '#0a0f19', minHeight: '100vh', color: 'white' }}>
        {/* ⚠️ NO BORRAR: navbar completo con todas las secciones */}
        <nav className="navbar">
          <Link to="/" style={{ display: 'flex', alignItems: 'center', textDecoration: 'none' }}>
            <img src="/logodtxi.png" alt="DTXI" style={{ height: '40px', width: '40px', objectFit: 'contain' }} />
          </Link>
          <Link to="/equipo-tactico" className="nav-link">MI EQUIPO TÁCTICO</Link>
          <Link to="/equipo-libre" className="nav-link">MI EQUIPO LIBRE</Link>
          <Link to="/prode" className="nav-link">PRODE</Link>
          <div className="dropdown">
            <span className="nav-link">TORNEOS ▼</span>
            <div className="dropdown-content">
              <Link to="/torneo-tactico">Torneo Táctico</Link>
              <Link to="/torneo-libre">Torneo Libre</Link>
            </div>
          </div>
          <Link to="/ranked" className="nav-link">POR LOS PUNTOS</Link>
          <div className="dropdown">
            <span className="nav-link">MINIJUEGOS ▼</span>
            <div className="dropdown-content">
              <Link to="/minijuegos/formaciones">Formaciones Míticas</Link>
              <Link to="/minijuegos/formidable">Formidable</Link>
              <Link to="/minijuegos/penales">Penales</Link>
            </div>
          </div>
          <Link to="/ranking" className="nav-link" style={{ marginLeft: 'auto' }}>RANKING</Link>
          <Link to="/clan" className="nav-link">CLUB</Link>
          <Link to="/mundial" className="nav-link">MUNDIAL</Link>

          {/* ⚠️ NO BORRAR: dropdown del usuario */}
          <div className="dropdown">
            <span className="nav-link" style={{ color: '#00f2ff', cursor: 'pointer' }}>
              {nickname || session.user.email.split('@')[0]}
              {(desafiosPendientes.length + notifComodines.length) > 0 && (
                <span style={{ marginLeft: '5px', fontSize: '0.75rem' }}>🔔</span>
              )} ▼
            </span>
            <div className="dropdown-content" style={{ right: 0, left: 'auto' }}>
              <Link to="/palmares">Palmarés</Link>
              {/* ⚠️ NO BORRAR: REGLAMENTO abre PDF en nueva pestaña */}
              <a href="/reglamento.pdf" target="_blank" rel="noreferrer">Reglamento</a>
              <span style={{ cursor: 'pointer' }} onClick={() => setMostrarCambioPassword(true)}>Cambiar contraseña</span>
              {/* ⚠️ NO BORRAR: CONTACTO abre modal de sugerencias */}
              <span style={{ cursor: 'pointer' }} onClick={() => setMostrarSugerencias(true)}>Contacto</span>
              {/* ⚠️ NO BORRAR: NOTIFICACIONES — desafíos ranked + comodines */}
              <div style={{ borderTop: '1px solid #1e293b', margin: '4px 0' }} />

              {/* Header notificaciones */}
              <div style={{ padding: '6px 14px 4px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <span style={{ color: '#64748b', fontSize: '0.68rem', textTransform: 'uppercase', letterSpacing: '1px', fontWeight: 'bold' }}>
                   Notificaciones
                </span>
                {notifComodines.length > 0 && (
                  <button onClick={async () => {
                    const ids = notifComodines.map(n => n.id);
                    await supabase.from('notificaciones').update({ leida: true }).in('id', ids);
                    setNotifComodines([]);
                  }} style={{ background: 'none', border: 'none', color: '#334155', cursor: 'pointer', fontSize: '0.7rem', padding: 0 }}>
                    Borrar todo
                  </button>
                )}
              </div>

              {/* Lista unificada */}
              <div style={{ maxHeight: '280px', overflowY: 'auto' }}>
                {desafiosPendientes.length === 0 && notifComodines.length === 0 ? (
                  <p style={{ color: '#334155', fontSize: '0.78rem', padding: '8px 14px 10px', margin: 0 }}>Sin notificaciones</p>
                ) : (
                  <>
                    {/* Notificaciones generales */}
                    {notifComodines.map(n => {
                      const emojiValido = n.emoji && !n.emoji.endsWith('.png') && !n.emoji.endsWith('.jpg');
                      return (
                        <div key={n.id} style={{ padding: '8px 14px', borderTop: '1px solid #0f172a', display: 'flex', alignItems: 'flex-start', gap: '8px' }}>
                          {emojiValido && (
                            <span style={{ fontSize: '1.1rem', flexShrink: 0, lineHeight: 1, marginTop: '1px' }}>{n.emoji}</span>
                          )}
                          <p style={{ margin: 0, color: '#94a3b8', fontSize: '0.78rem', flex: 1, lineHeight: 1.4 }}>{n.texto}</p>
                          <button onClick={async () => {
                            await supabase.from('notificaciones').update({ leida: true }).eq('id', n.id);
                            setNotifComodines(prev => prev.filter(x => x.id !== n.id));
                          }} style={{ background: 'none', border: 'none', color: '#334155', cursor: 'pointer', fontSize: '0.8rem', flexShrink: 0, padding: '0 0 0 4px', lineHeight: 1 }}>✕</button>
                        </div>
                      );
                    })}

                    {/* Desafíos pendientes */}
                    {desafiosPendientes.map(d => (
                      <div key={d.id} style={{ padding: '8px 14px', borderTop: '1px solid #0f172a' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '6px' }}>
                          <span style={{ fontSize: '0.95rem' }}></span>
                          <p style={{ margin: 0, color: '#94a3b8', fontSize: '0.78rem', lineHeight: 1.3 }}>
                            <span style={{ color: '#e2e8f0', fontWeight: 'bold' }}>
                              {d.retador?.clan_tag ? `[${d.retador.clan_tag}] ` : ''}{d.retador?.nickname || '?'}
                            </span>
                            <span style={{ color: '#64748b' }}> te desafía</span>
                          </p>
                        </div>
                        <div style={{ display: 'flex', gap: '6px' }}>
                          <button onClick={() => { setDesafiosPendientes(prev => prev.filter(x => x.id !== d.id)); responderDesafio(d.id, true); }}
                            style={{ flex: 1, background: '#22c55e22', border: '1px solid #22c55e55', borderRadius: '6px', padding: '5px', color: '#22c55e', fontSize: '0.72rem', fontWeight: 'bold', cursor: 'pointer' }}>
                            ✓ Aceptar
                          </button>
                          <button onClick={() => { setDesafiosPendientes(prev => prev.filter(x => x.id !== d.id)); responderDesafio(d.id, false); }}
                            style={{ flex: 1, background: '#ef444422', border: '1px solid #ef444455', borderRadius: '6px', padding: '5px', color: '#ef4444', fontSize: '0.72rem', fontWeight: 'bold', cursor: 'pointer' }}>
                            ✕ Rechazar
                          </button>
                        </div>
                      </div>
                    ))}
                  </>
                )}
              </div>
              <div style={{ borderTop: '1px solid #1e293b', margin: '4px 0' }} />
              {/* ⚠️ NO BORRAR: ADMIN solo visible para admins */}
              {esAdmin && <Link to="/admin-puntos" style={{ color: '#f59e0b' }}>Admin</Link>}
              <span style={{ cursor: 'pointer', color: '#ff007f' }} onClick={() => supabase.auth.signOut()}>Salir</span>
            </div>
          </div>

          {/* ── MOBILE: botón hamburguesa ── */}
          <button
            className={`navbar-hamburger${menuMovilAbierto ? ' abierto' : ''}`}
            onClick={() => setMenuMovilAbierto(v => !v)}
            aria-label="Menú"
          >
            <span /><span /><span />
          </button>
        </nav>

        {/* ── MOBILE: overlay y drawer ── */}
        <div
          className={`navbar-overlay${menuMovilAbierto ? ' visible' : ''}`}
          onClick={() => setMenuMovilAbierto(false)}
        />
        <div className={`navbar-drawer${menuMovilAbierto ? ' abierto' : ''}`}>
          {/* Cabecera del drawer */}
          <div className="drawer-header">
            <Link to="/" onClick={() => setMenuMovilAbierto(false)} style={{ display: 'flex', alignItems: 'center', textDecoration: 'none' }}>
              <img src="/logodtxi.png" alt="DTXI" style={{ height: '36px', width: '36px', objectFit: 'contain' }} />
            </Link>
            <button className="drawer-close" onClick={() => setMenuMovilAbierto(false)}>✕</button>
          </div>

          {/* Nick del usuario */}
          <div className="drawer-user-nick">
            {nickname || session.user.email.split('@')[0]}
            {(desafiosPendientes.length + notifComodines.length) > 0 && (
              <span style={{ marginLeft: '8px', background: '#ef4444', color: '#fff', borderRadius: '10px', padding: '1px 7px', fontSize: '0.65rem', fontWeight: 'bold' }}>
                {desafiosPendientes.length + notifComodines.length}
              </span>
            )}
          </div>

          {/* MI EQUIPO (acordeón) */}
          <button
            className={`drawer-accordion-btn${submenuMovil === 'equipo' ? ' abierto' : ''}`}
            onClick={() => setSubmenuMovil(v => v === 'equipo' ? null : 'equipo')}
          >
             MI EQUIPO <span className="drawer-accordion-arrow">▼</span>
          </button>
          <div className={`drawer-submenu${submenuMovil === 'equipo' ? ' abierto' : ''}`}>
            <Link to="/equipo-tactico" className="drawer-link" onClick={() => setMenuMovilAbierto(false)}>Táctico</Link>
            <Link to="/equipo-libre" className="drawer-link" onClick={() => setMenuMovilAbierto(false)}>Libre</Link>
          </div>

          {/* TORNEOS (acordeón) */}
          <button
            className={`drawer-accordion-btn${submenuMovil === 'torneos' ? ' abierto' : ''}`}
            onClick={() => setSubmenuMovil(v => v === 'torneos' ? null : 'torneos')}
          >
             TORNEOS <span className="drawer-accordion-arrow">▼</span>
          </button>
          <div className={`drawer-submenu${submenuMovil === 'torneos' ? ' abierto' : ''}`}>
            <Link to="/torneo-tactico" className="drawer-link" onClick={() => setMenuMovilAbierto(false)}>Torneo Táctico</Link>
            <Link to="/torneo-libre" className="drawer-link" onClick={() => setMenuMovilAbierto(false)}>Torneo Libre</Link>
          </div>

          <Link to="/prode" className="drawer-link" onClick={() => setMenuMovilAbierto(false)}>PRODE</Link>

          {/* MINIJUEGOS (acordeón) */}
          <button
            className={`drawer-accordion-btn${submenuMovil === 'minijuegos' ? ' abierto' : ''}`}
            onClick={() => setSubmenuMovil(v => v === 'minijuegos' ? null : 'minijuegos')}
          >
             MINIJUEGOS <span className="drawer-accordion-arrow">▼</span>
          </button>
          <div className={`drawer-submenu${submenuMovil === 'minijuegos' ? ' abierto' : ''}`}>
            <Link to="/minijuegos/formaciones" className="drawer-link" onClick={() => setMenuMovilAbierto(false)}> Formaciones Míticas</Link>
            <Link to="/minijuegos/formidable" className="drawer-link" onClick={() => setMenuMovilAbierto(false)}> Formidable</Link>
            <Link to="/minijuegos/penales" className="drawer-link" onClick={() => setMenuMovilAbierto(false)}> Penales</Link>
          </div>

          {/* Links directos */}
          <Link to="/ranked" className="drawer-link" onClick={() => setMenuMovilAbierto(false)}> POR LOS PUNTOS</Link>
          <Link to="/ranking" className="drawer-link" onClick={() => setMenuMovilAbierto(false)}> RANKING</Link>
          <Link to="/clan" className="drawer-link" onClick={() => setMenuMovilAbierto(false)}> CLUB</Link>
          <Link to="/mundial" className="drawer-link" onClick={() => setMenuMovilAbierto(false)}>MUNDIAL</Link>

          <div className="drawer-separator" />

          {/* USUARIO (acordeón) */}
          <button
            className={`drawer-accordion-btn${submenuMovil === 'usuario' ? ' abierto' : ''}`}
            onClick={() => setSubmenuMovil(v => v === 'usuario' ? null : 'usuario')}
          >
             MI CUENTA <span className="drawer-accordion-arrow">▼</span>
          </button>
          <div className={`drawer-submenu${submenuMovil === 'usuario' ? ' abierto' : ''}`}>
            <Link to="/palmares" className="drawer-link" onClick={() => setMenuMovilAbierto(false)}> Palmarés</Link>
            <a href="/reglamento.pdf" target="_blank" rel="noreferrer" className="drawer-link" onClick={() => setMenuMovilAbierto(false)}>Reglamento</a>
            <span className="drawer-link" style={{ cursor: 'pointer' }} onClick={() => { setMostrarCambioPassword(true); setMenuMovilAbierto(false); }}> Cambiar contraseña</span>
            <span className="drawer-link" style={{ cursor: 'pointer' }} onClick={() => { setMostrarSugerencias(true); setMenuMovilAbierto(false); }}> Contacto</span>
            {esAdmin && <Link to="/admin-puntos" className="drawer-link" style={{ color: '#f59e0b' }} onClick={() => setMenuMovilAbierto(false)}> Admin</Link>}
          </div>

          {/* Notificaciones en el drawer */}
          {(desafiosPendientes.length + notifComodines.length) > 0 && (
            <>
              <div className="drawer-separator" />
              <div style={{ padding: '6px 20px 4px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <span className="drawer-notif-header" style={{ margin: 0 }}>🔔 Notificaciones</span>
                {notifComodines.length > 0 && (
                  <button onClick={async () => {
                    const ids = notifComodines.map(n => n.id);
                    await supabase.from('notificaciones').update({ leida: true }).in('id', ids);
                    setNotifComodines([]);
                  }} style={{ background: 'none', border: 'none', color: '#334155', cursor: 'pointer', fontSize: '0.72rem', padding: 0 }}>
                    Borrar todo
                  </button>
                )}
              </div>
              {notifComodines.map(n => {
                const emojiValido = n.emoji && !n.emoji.endsWith('.png') && !n.emoji.endsWith('.jpg');
                return (
                  <div key={n.id} style={{ padding: '8px 20px', display: 'flex', alignItems: 'flex-start', gap: '8px', borderBottom: '1px solid #0f172a' }}>
                    {emojiValido && <span style={{ fontSize: '1.1rem', flexShrink: 0, lineHeight: 1, marginTop: '2px' }}>{n.emoji}</span>}
                    <p style={{ margin: 0, color: '#94a3b8', fontSize: '0.8rem', flex: 1, lineHeight: 1.4 }}>{n.texto}</p>
                    <button onClick={async () => {
                      await supabase.from('notificaciones').update({ leida: true }).eq('id', n.id);
                      setNotifComodines(prev => prev.filter(x => x.id !== n.id));
                    }} style={{ background: 'none', border: 'none', color: '#334155', cursor: 'pointer', fontSize: '0.9rem', flexShrink: 0, padding: '0 0 0 4px' }}>✕</button>
                  </div>
                );
              })}
              {desafiosPendientes.map(d => (
                <div key={d.id} style={{ padding: '8px 20px', borderBottom: '1px solid #0f172a' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '6px' }}>
                    <span style={{ fontSize: '0.95rem' }}></span>
                    <p style={{ margin: 0, color: '#94a3b8', fontSize: '0.8rem', lineHeight: 1.3 }}>
                      <span style={{ color: '#e2e8f0', fontWeight: 'bold' }}>
                        {d.retador?.clan_tag ? `[${d.retador.clan_tag}] ` : ''}{d.retador?.nickname || '?'}
                      </span>
                      <span style={{ color: '#64748b' }}> te desafía</span>
                    </p>
                  </div>
                  <div style={{ display: 'flex', gap: '8px' }}>
                    <button onClick={() => { setDesafiosPendientes(prev => prev.filter(x => x.id !== d.id)); responderDesafio(d.id, true); }}
                      style={{ flex: 1, background: '#22c55e22', border: '1px solid #22c55e55', borderRadius: '6px', padding: '7px', color: '#22c55e', fontSize: '0.8rem', fontWeight: 'bold', cursor: 'pointer' }}>
                      ✓ Aceptar
                    </button>
                    <button onClick={() => { setDesafiosPendientes(prev => prev.filter(x => x.id !== d.id)); responderDesafio(d.id, false); }}
                      style={{ flex: 1, background: '#ef444422', border: '1px solid #ef444455', borderRadius: '6px', padding: '7px', color: '#ef4444', fontSize: '0.8rem', fontWeight: 'bold', cursor: 'pointer' }}>
                      ✕ Rechazar
                    </button>
                  </div>
                </div>
              ))}
            </>
          )}

          <div className="drawer-separator" />
          <span className="drawer-link" style={{ color: '#ff007f', cursor: 'pointer' }} onClick={() => supabase.auth.signOut()}> Salir</span>
        </div>

        {/* ⚠️ NO BORRAR: modal de sugerencias/contacto */}
        {mostrarSugerencias && <ModalSugerencias session={session} onClose={() => setMostrarSugerencias(false)} />}
          {mostrarCambioPassword && (<ModalCambioPassword onClose={() => setMostrarCambioPassword(false)} />
)}
          

        {/* ⚠️ NO BORRAR: toasts de medallas e hitos */}
        {toastMedalla?.tipo === 'jugada_preparada' && (
          <ToastJugadaPreparada
            emoji={toastMedalla.emoji}
            nombre={toastMedalla.nombre}
            onCerrar={() => setToastMedalla(null)}
          />
        )}
        {toastMedalla?.tipo === 'medalla' && (
          <ToastMedalla
            emoji={toastMedalla.emoji}
            nombre={toastMedalla.nombre}
            onCerrar={() => setToastMedalla(null)}
          />
        )}

        <AppRoutes
          session={session} esAdmin={esAdmin} nickname={nickname}
          draftResult={draftResult} setDraftResult={setDraftResult}
          mostrarSorteo={mostrarSorteo} setMostrarSorteo={setMostrarSorteo}
          equipoActual={equipoActual} setEquipoActual={setEquipoActual}
          equipoLibre={equipoLibre} setEquipoLibre={setEquipoLibre}
          formacionLibre={formacionLibre} setFormacionLibre={setFormacionLibre}
          restriccionesActualizadas={restriccionesActualizadas}
          posActual={posActual}
          jornadaActiva={jornadaActiva}
          jornadaViendo={jornadaViendo} setJornadaViendo={setJornadaViendoManual}
          confirmado={confirmado} setConfirmado={setConfirmado}
          capitanIndex={capitanIndex} setCapitanIndex={setCapitanIndex}
          ventana={ventana} setVentana={setVentana}
          jornadasDisponibles={jornadasDisponibles} setJornadasDisponibles={setJornadasDisponibles}
          efectosComodines={efectosComodines} setEfectosComodines={setEfectosComodines}
          presupuestoBonus={presupuestoBonus} setPresupuestoBonus={setPresupuestoBonus}
          sorteoCheckpoint={sorteoCheckpoint}
          uiProps={uiProps}
          copiarTacticoALibre={copiarTacticoALibre}
          copiarLibreATactico={copiarLibreATactico}
        />
      </div>
          <TutorialMobile />
    </Router>
  );
}

function AppRoutes({
  session, esAdmin, nickname,
  draftResult, setDraftResult, mostrarSorteo, setMostrarSorteo,
  equipoActual, setEquipoActual, equipoLibre, setEquipoLibre,
  formacionLibre, setFormacionLibre, restriccionesActualizadas, posActual,
  jornadaActiva, jornadaViendo, setJornadaViendo,
  confirmado, setConfirmado, capitanIndex, setCapitanIndex,
  ventana, setVentana, jornadasDisponibles, setJornadasDisponibles,
  efectosComodines, setEfectosComodines, presupuestoBonus, setPresupuestoBonus,
  sorteoCheckpoint, uiProps,
  copiarTacticoALibre, copiarLibreATactico,
}) {
  const location = useLocation();
  const path = location.pathname;

  const tacticoProps = {
    session, draftResult, setDraftResult, mostrarSorteo, setMostrarSorteo,
    equipoActual, setEquipoActual, restriccionesActualizadas, posActual,
    jornadaActiva, jornadaViendo, setJornadaViendo,
    confirmado, setConfirmado, capitanIndex, setCapitanIndex,
    ventana, setVentana, jornadasDisponibles, setJornadasDisponibles,
    efectosComodines, setEfectosComodines, presupuestoBonus, setPresupuestoBonus,
    sorteoCheckpoint,
    onCopiarALibre: copiarTacticoALibre,
    ...uiProps,
  };

  const libreProps = {
    session, equipoLibre, setEquipoLibre,
    formacionLibre, setFormacionLibre, jornadaActiva,
    onCopiarATactico: copiarTacticoALibre,
    ...uiProps,
  };

  return (
    <>
      {/* ⚠️ NO BORRAR: siempre montados con display:none para evitar parpadeo */}
      <div style={{ display: path === '/equipo-tactico' ? 'block' : 'none' }}>
        <EquipoTactico {...tacticoProps} />
      </div>
      <div style={{ display: path === '/equipo-libre' ? 'block' : 'none' }}>
        <EquipoLibre {...libreProps} />
      </div>
      {/* ⚠️ NO BORRAR: RankedPage siempre montado para evitar parpadeo y mantener estado */}
      <div style={{ display: path === '/ranked' ? 'block' : 'none' }}>
        <RankedPage userId={session.user.id} />
      </div>

      {path !== '/equipo-tactico' && path !== '/equipo-libre' && path !== '/ranked' && (
        <Routes>
          <Route path="/" element={<Inicio session={session} draftResult={draftResult} equipoActual={equipoActual} equipoLibre={equipoLibre} formacionLibre={formacionLibre} nickname={nickname} jornadaActiva={jornadaActiva} capitanIndex={capitanIndex} />} />
          <Route path="/torneo-tactico" element={<TorneoPage session={session} tipo="tactico" />} />
          <Route path="/torneo-libre" element={<TorneoPage session={session} tipo="libre" />} />
          <Route path="/torneo/:id" element={<TorneoDetalle session={session} esAdmin={esAdmin} />} />
          <Route path="/torneo/:id/admin" element={<AdminTorneo session={session} esAdmin={esAdmin} />} />
          <Route path="/palmares" element={<Palmares session={session} />} />
          <Route path="/palmares/:userId" element={<Palmares session={session} />} />
          <Route path="/ranking" element={<RankingGeneral session={session} />} />
          <Route path="/prode" element={<Prode session={session} />} />
          <Route path="/unirse/:codigo" element={<UnirseProde session={session} />} />
          <Route path="/minijuegos/*" element={<MinijuegosHub session={session} />} />
          {/* ⚠️ NO BORRAR: rutas de admin y mundial */}
          <Route path="/admin-puntos" element={<AdminPuntos session={session} esAdmin={esAdmin} />} />
          <Route path="/mundial" element={<MundialPage session={session} />} />
          <Route path="/clan" element={<ClanPage session={session} />} />
        </Routes>
      )}
      <InstallPWA />
    </>
  );
}

export default App;